import React from 'react';
import cart from '../../assets/images/checkoutcart.jpg';

const CustomerHero: React.FC = () => {
  return (
    <section className="relative flex flex-col items-center justify-center min-h-screen bg-dark text-white px-4 pt-24 pb-16 overflow-hidden">
      {/* Background shopping carts and bags (using absolute positioning) */}
      <div className="absolute inset-0 overflow-hidden">
        <img 
          src={cart} 
          alt="Shopping cart" 
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
      </div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-4">
          <div>Shop Without Hesitation.</div>
          <div className="text-primary">Refund Without Questions.</div>
        </h1>
        
        <p className="text-lg md:text-xl text-gray-300 mt-6 max-w-3xl mx-auto">
          ValetPe guarantees instant refunds, exclusive discounts and zero hassle. Your ultimate shopping companion is here!
        </p>
      </div>
    </section>
  );
};

export default CustomerHero;